module.exports = __webpack_public_path__ + "media/country_flags/ag-7d4bcf8a.png";